import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";
import { AdalHttp } from '../../services/adal.http.service';
@Injectable()
export class AnnotationStreamManagement {
    constructor(private http: AdalHttp) {
    }

    annotationStreamsByOwnerId(ownerId: string, tenants:string): Observable<any> {
        let url = `api/tenants/${tenants}/annotationmanagement/annotationstreams/owner/${ownerId}/`;

        return this.http.get(url)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    annotationStreamByStreamId(streamId: string,tenants:string): Observable<any> {
        let url = `/api/tenants/${tenants}/annotationmanagement/annotationstreams/stream/${streamId}/`;

        return this.http.get(url)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
    
    deleteStreamBatch(streamIds:Array<string>,tenants:string): Observable<any> {
        let url = `api/tenants/${tenants}/annotationmanagement/annotationstreamsbatch/`;
        return this.http.delete(url, { body: streamIds }).catch((error: any) => {
                return Observable.throw(error);
            });
    }

    getAllAnnotationStreams(tenants:string): Observable<any> {
        let url = `/api/tenants/${tenants}/annotationmanagement/annotationstreams`;

        return this.http.get(url)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    getSubscriptionsByMessageCount(messageCount: string,tenants:string): Observable<any> {
        let url = `/api/tenants/${tenants}/annotationmanagement/subscriptions/messagecount/${messageCount}/`;

        return this.http.get(url)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/annotationStreamManagement/annotation-stream-management.service.ts
 **/